import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './styles.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    message: '',
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  
  // Fonction pour basculer l'état du menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  // Fonction pour fermer le menu lors d'un clic sur un lien
  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Remplacer par l'URL de votre serveur backend
      const response = await axios.post('http://www.renovpiscines13.fr/api.php', formData);
      
      if (response.data.success) {
        setFormStatus({
          submitted: true,
          success: true,
          message: 'Merci pour votre message ! Nous vous contacterons bientôt.'
        });
        
        // Réinitialiser le formulaire
        setFormData({
          nom: '',
          email: '',
          telephone: '',
          message: '',
        });
      } else {
        setFormStatus({
          submitted: true,
          success: false,
          message: response.data.message || 'Une erreur est survenue. Veuillez réessayer.'
        });
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi du formulaire:', error);
      setFormStatus({
        submitted: true,
        success: false,
        message: 'Une erreur est survenue lors de l\'envoi du message. Veuillez réessayer.'
      });
    } finally {
      setLoading(false);
      
      // Réinitialiser le message après 5 secondes si c'est un succès
      if (formStatus.success) {
        setTimeout(() => {
          setFormStatus({
            submitted: false,
            success: false,
            message: ''
          });
        }, 5000);
      }
    }
  };

  return (
    <div className="page-container">
      <header className="header">
        <div className="logo">
          <h1>RENOV-PISCINES 13</h1>
        </div>
        <nav className={`navigation ${menuOpen ? 'mobile-menu-open' : ''}`}>
          <ul>
            <li><Link to="/" className="active" onClick={closeMenu}>Accueil</Link></li>
            <li><Link to="/projets" onClick={closeMenu}>Nos précédents chantiers</Link></li>
            <li><Link to="/contact" onClick={closeMenu}>Nous contacter</Link></li>
          </ul>
        </nav>
        <div className={`hamburger-menu ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>

      <main className="contact-main">
        <section className="contact-hero">
          <h2>Nous contacter</h2>
          <p>N'hésitez pas à nous contacter pour toute demande d'information ou de devis</p>
        </section>

        <section className="contact-container">
          <div className="contact-info">
            <h3>Coordonnées</h3>
            <div className="info-item">
              <span className="info-icon">📱</span>
              <div className="info-content">
                <h4>Téléphone</h4>
                <p>06 51 51 29 93</p>
              </div>
            </div>
            <div className="info-item">
              <span className="info-icon">✉️</span>
              <div className="info-content">
                <h4>Email</h4>
                <p>renovpiscines13@outlook.fr</p>
              </div>
            </div>
            <div className="info-item">
              <span className="info-icon">📍</span>
              <div className="info-content">
                <h4>Adresse</h4>
                <p>13011 Marseille</p>
              </div>
            </div>
            <div className="info-item">
              <span className="info-icon">🕒</span>
              <div className="info-content">
                <h4>Horaires</h4>
                <p>Lundi - Vendredi: 8h - 19h<br />Samedi: 8h - 12h</p>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h3>Formulaire de contact</h3>
            {formStatus.submitted && (
              <div className={`form-message ${formStatus.success ? 'form-success-message' : 'form-error-message'}`}>
                <p>{formStatus.message}</p>
              </div>
            )}
            
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="nom">Nom et prénom *</label>
                <input
                  type="text"
                  id="nom"
                  name="nom"
                  value={formData.nom}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="telephone">Téléphone *</label>
                <input
                  type="tel"
                  id="telephone"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                  disabled={loading}
                ></textarea>
              </div>

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Envoi en cours...' : 'Envoyer'}
              </button>
            </form>
          </div>
        </section>

      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>RENOV-PISCINES 13</h3>
            <p>Votre spécialiste de la rénovation de piscines dans les Bouches-du-Rhône.</p>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p>Email: renovpiscines13@outlook.fr</p>
            <p>Téléphone: 06 51 51 29 93</p>
          </div>
          <div className="footer-section">
            <h3>Horaires</h3>
            <p>Lundi - Vendredi: 8h - 19h</p>
            <p>Samedi: 8h - 12h</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 RENOV-PISCINES 13. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
};

export default Contact;